import CosmosJobsDbRecordBase from '@/models/CosmosJobsDbRecordBase'

export default class JobDelay extends CosmosJobsDbRecordBase {
  public reason: string
  public notes: string
}
